var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"inset":"","label":"Grouper les CA"},model:{value:(_vm.groupCA),callback:function ($$v) {_vm.groupCA=$$v},expression:"groupCA"}})}
var staticRenderFns = []

export { render, staticRenderFns }